import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class LoadingService {
  public readonly loading$: Observable<boolean>;

  private _loading = new BehaviorSubject<boolean>(false);

  constructor() {
    this.loading$ = this._loading.asObservable();
  }

  show() {
    this._loading.next(true);
  }

  hide() {
    this._loading.next(false);
  }
}
